export enum PRPayTypes {
	//TABLE PR_Ref_PayType

	Hourly = 1,
	Salary = 2,
	Daily = 3,
	Other = 4,
	HourlySubstitute = 5,
}
